import { toTitleCase } from "@travel/shared/utils";
export function mutateLocation(data) {
    var _a, _b;
    var type = validateLocationType(data.type || data.dataType) || "";
    var location = {
        //...data,
        id: getLocationID(data, type),
        type: type,
        country: data.country,
    };
    switch (type) {
        case "airport":
            location.name = location.displayName = data.airport;
            break;
        case "city":
            var stateCodeOrCountry = data.country_code === "US" ? data.state_code : data.country;
            location.name = toTitleCase(data.city).trimStart().trimEnd();
            location.displayName =
                location.name !== stateCodeOrCountry
                    ? "".concat(location.name, ", ").concat(stateCodeOrCountry)
                    : location.name;
            break;
        case "hotel":
            location.name = location.displayName = data.hotel_name;
            /*
            location.displayName = `${data.hotel_name}${
              data.city_name || data.city
                ? ` - ${toTitleCase(data.city_name || data.city)}, ${
                    data.state_code || data.country_code
                  }`
                : ""
            }}`;
             */
            break;
        case "poi":
            location.name = location.displayName = toTitleCase(data.poi_name);
            location.coords = {
                latitude: Number((_a = data.geo_location) === null || _a === void 0 ? void 0 : _a.lat),
                longitude: Number((_b = data.geo_location) === null || _b === void 0 ? void 0 : _b.lon),
            };
            break;
        case "region":
            location.name = location.displayName = toTitleCase(data.region_name);
            break;
    }
    return location;
}
function getLocationID(location, type) {
    switch (type) {
        case "airport":
            return location.iata;
        case "city":
            return location.cityid_ppn;
        case "hotel":
            return location.hotelid_ppn;
        case "poi":
            return location.poiid_ppn;
        case "region":
            return location.cityids_ppn;
        default:
            return location.id;
    }
}
var OTHER_POSSIBLE_NAMES = {
    city: ["cities"],
    airport: ["airports"],
    hotel: ["hotels"],
    poi: ["pointofinterest"],
};
export function validateLocationType(possibleType) {
    if (OTHER_POSSIBLE_NAMES[possibleType])
        return possibleType;
    for (var type in OTHER_POSSIBLE_NAMES) {
        var otherNames = OTHER_POSSIBLE_NAMES[type];
        if (otherNames.indexOf(possibleType) > -1) {
            return type;
        }
    }
}
